import {STATE_NAMES} from './state-names';

export const ROUTE_NAMES = {
  userProfile: [{
    name: 'Профиль'
  }],
  users: [{
    name: 'Пользователи'
  }],
  travels: [{
    name: 'Путешествия',
    url: STATE_NAMES.travels,
  }],
  events: [{
    name: 'События',
    url: STATE_NAMES.events,
  }],
  main: [{
    name: 'Главная',
    url: STATE_NAMES.main,
  }],
  chat: [{
    name: 'Чат',
    url: STATE_NAMES.chat,
  }],

};
